import { ref, onMounted } from 'vue';
import { useFetch } from '@apparatix/composables';
import { User } from '@apparatix/types';

interface UserDto {
  user_id: number;
  user_name: string;
  user_userid: string;
  user_type: string;
  roles: string[];
}

export const useImpersonation = (realUser: User) => {
  const { get, post } = useFetch();

  const users = ref<Array<UserDto>>([]);
  const isLoading = ref(false);

  const hasPermission = realUser.isAdmin || realUser.isTechnoGeek;

  const impersonateUser = async (user: UserDto): Promise<boolean> => {
    if (!hasPermission) return false;
    try {
      const result = await post('/masquerade', user) as { success: boolean };
      if (result.success) {
        window.location.reload();
        return true;
      }
      return false;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const disableImpersonation = async () => {
    if (!hasPermission) return;
    try {
      post('/masquerade/disable', {}).then(() => window.location.reload());
    } catch (err) {
      console.warn(err);
    }
  };


  onMounted(() => {
    if (!hasPermission) return;
    isLoading.value = true;
    get('/masquerade').then((userList: Array<UserDto>) => {
      if (userList && userList.length) {
        users.value = userList;
        isLoading.value = false;
      }
    });
  });

  return {
    isLoading,
    users,
    impersonateUser,
    disableImpersonation,
    hasPermission,
  };
};
